<template>
  <div>
    <a-card>
      <!-- 查询 -->
      <SearchView
        :renderItem="searchSchema"
        formLayout="inline"
        :initialValues="searchData"
        @fetchSearch="handelSearch"
        :isExpandShowOrNot="false"
      ></SearchView>
    </a-card>
    <a-card style="margin-top:20px;">
      <div class="text-right">
        <a-button type="primary" icon="plus" @click="handleAddBtn">
          添加
        </a-button>
      </div>
      <!-- 列表 -->
      <TableView
        :scroll="scroll"
        :loading="loading"
        ref="table"
        :pagination="pageData"
        :columns="columns"
        :data="tableData"
        v-on:handlePagination="handlePagination"
      >
        <template v-slot:action="{ tableRow }">
          <a href="javascript:void(0)" @click="handelView(tableRow)">
            查看详情
          </a>
        </template>
      </TableView>
    </a-card>
  </div>
</template>
<script>
import { SearchView, TableView } from 'lxfintech-fe'
import { mapMutations } from 'vuex'
import { getTableData } from './api'
import { SET_BUREAU } from 'config/mutation-types/app'
import moment from 'moment'
import mixin from './mixin'
const BRAZIL_VALUES = [3, 4, 6]
const BRADSTREET_GLOBAL_VALUES = [1, 2]
const CREDIT_RISK_MONITOR_VALUES = [5, 7, 8, 9]
const bureauSearch = [
  {
    name: 'Dun & Bradstreet Global',
    id: '1',
  },
  {
    name: 'Credit Risk Monitor',
    id: '2',
  },
  {
    name: '安华理达',
    id: '3',
  },
]
const disposeProductNameList = [
  {
    text: 'Lookup',
    value: 1,
  },
  {
    text: 'Global Data Packet/Report',
    value: 2,
  },
  {
    text: '查询',
    value: 3,
  },
  {
    text: '调取客户工商大数',
    value: 4,
  },
  {
    text: '调取客户详财(2年)',
    value: 6,
  },
  {
    text: 'Company Search by Name',
    value: 5,
  },
  {
    text: 'Company Search by Ticker',
    value: 8,
  },
  {
    text: 'Company Financial Report',
    value: 7,
  },
  {
    text: '财务大数报告',
    value: 9,
  },
]
export default {
  mixins: [mixin],
  components: {
    SearchView,
    TableView,
  },
  data() {
    return {
      loading: false,
      bureauSearch,
      searchData: {},
      moment,
      disposeProductNameList,
      companyCode: '',
      tableData: [],
      scroll: { x: 1000 }, //滚动设置
    }
  },
  mounted() {
    this.companyId = this.$route.params.id
    this._getTableData()
  },
  methods: {
    ...mapMutations('app', [SET_BUREAU]),

    ProductNameList(name) {
      console.log(this.searchData)
      this.searchSchema[0].value = name
      let arr = null
      switch (name) {
        case '1':
          arr = this.disposeProductNameList.filter(item =>
            BRADSTREET_GLOBAL_VALUES.includes(item.value),
          )
          break
        case '2':
          arr = this.disposeProductNameList.filter(item =>
            CREDIT_RISK_MONITOR_VALUES.includes(item.value),
          )
          break
        case '3':
          arr = this.disposeProductNameList.filter(item =>
            BRAZIL_VALUES.includes(item.value),
          )
          break
        case '4':
          arr = this.disposeProductNameList.filter(item =>
            [9].includes(item.value),
          )
          break
      }
      this.searchSchema[1].selectList = arr
    },
    //点击查询
    handelSearch(query) {
      bureauSearch.map(item => {
        if (item.id === query.bureauName) {
          query.bureauName = item.name
        }
        return query.bureauName
      })
      disposeProductNameList.forEach(item => {
        if (item.value === query.productName) {
          query.productName = item.text
        }
        return query.productName
      })
      for (let key in query) {
        this.searchData[key] = query[key]
      }
      this._getTableData()
    },
    //分页
    handlePagination(pagination) {
      const { current, pageSize, total } = pagination
      this.pageData.current = current
      this.pageData.pageSize = pageSize
      this.pageData.total = total
      this._getTableData()
    },
    //获取table数据
    async _getTableData() {
      this.loading = true
      const { current, pageSize } = this.pageData
      const query = {
        companyId: this.companyId,
        ...this.searchData,
        size: pageSize,
        current,
      }
      getTableData(query).then(({ data: { total, records } }) => {
        this.loading = false
        this.tableData = records
        this.tableData.map(item => {
          item.createTime = moment(item.createTime).format('YYYY-MM-DD')
          item.updateTime = moment(item.updateTime).format('YYYY-MM-DD')
        })
        this.pageData.total = total
      })
    },
    handelView(row) {
      console.log(row)
      const { productNameInt, dnbReportProductName } = row
      const query = {}
      query.productName = productNameInt
      if (dnbReportProductName) {
        query.globalReportType = dnbReportProductName
      }
      this.$router.push({
        name: 'mechanism-report-detail',
        query,
      })
      this.SET_BUREAU(row)
    },
    handleAddBtn() {
      this.$router.push({
        name: 'mechanism-report-add',
        params: { customerId: this.$route.params.id },
      })
    },
  },
}
</script>
